"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Settings_1 = __importDefault(require("configs/Settings"));
const ClassConstants_1 = require("./ClassConstants");
const request_1 = __importDefault(require("@hotmart/request"));
request_1.default.register(`${Settings_1.default.api.class}/v4/classes`, {
    get: {
        [ClassConstants_1.ClassEndpointKeys.GetClassesBySubdomain]: '/',
        [ClassConstants_1.ClassEndpointKeys.GetMembershipClassAndOffersBySubdomain]: '/offers',
        [ClassConstants_1.ClassEndpointKeys.GetClassById]: '/:id'
    },
    post: {
        [ClassConstants_1.ClassEndpointKeys.CreateClass]: '/'
    },
    put: {
        [ClassConstants_1.ClassEndpointKeys.UpdateClass]: '/:id'
    },
    delete: {
        [ClassConstants_1.ClassEndpointKeys.DeleteClass]: '/:id'
    }
});
request_1.default.register(`${Settings_1.default.api.class}/v5/classes`, {
    get: {
        [ClassConstants_1.ClassEndpointKeys.GetClasses]: '/'
    }
});
request_1.default.register(`${Settings_1.default.api.clubUser}/v4`, {
    get: {
        [ClassConstants_1.ClassEndpointKeys.GetUserCount]: '/users/count'
    }
});
request_1.default.register(`${Settings_1.default.api.content}/v1/module-class`, {
    put: {
        [ClassConstants_1.ClassEndpointKeys.UpdateClassModules]: '/:id?extra=:extra'
    }
});
